import { useState } from "react";
import intl from 'components/i18n/ReactIntlWrapper';
import Spinner from '../../Spinner';
import {
  Box,
  } from '@mui/material';
import { DataGrid, GridColDef, GridInitialState, GridSortModel } from '@mui/x-data-grid';
import { DEFAULT_PAGINATION } from 'hooks/useSearch';
import { getUserEntity } from 'common/UserEntityProvider';
import DefaultActions from 'components/DataGrid/DefaultActions';
import { usePaginationPreference } from 'hooks/usePaginationPreference';


const JobList = ({ data, loading, handleJobEdit, handleTaskJob, handleJobDelete, disabled }) => {
	const entityType = getUserEntity();
    const [pagination, setPagination] = usePaginationPreference('projectJobs', 10);
    const [sortModel, setSortModel] = useState<GridSortModel>([{ field: 'Description', sort: 'asc' }]);
    
    
    const handleSortModelChange = (model: GridSortModel) => {
      setSortModel(model);
    };
  

	const INITIAL_STATE: GridInitialState = {
		pagination: {
		  paginationModel: {
			page: DEFAULT_PAGINATION.pageNum,
			pageSize: DEFAULT_PAGINATION.pageSize,
		  },
		},
		sorting: {
		  sortModel: [
			{
			  field: 'Description',
			  sort: 'asc',
			},
		  ],
		},
	  };

  const columns: GridColDef[] = [
    {
      field: 'description',
      headerName: intl.get('jobList.table.thead.job'),
      width: 250,
      flex: 1,
      renderCell: (params) => <>{params.row?.description || ''}</>,
    },
	  {
      field: 'billable',
      headerName: intl.get('jobList.table.thead.billable'),
      width: 250,
      flex: 1,
    },
    {
      field: 'idJobType',
      headerName: intl.get('jobList.table.thead.jobType'),
      width: 250,
      flex: 1,
      renderCell: (params) => <>{params.row?.jobType?.description || ''}</>,
    },
    {
      field: 'actions',
      headerName: '',
      width: 150,
      renderCell: (params) => (
        <DefaultActions
            row={params?.row}
            entityType={entityType.entityType}
            onEdit={() => handleJobEdit(params?.row?.id)}
            onView={() => handleTaskJob(params?.row?.id)}
            onDelete={() => handleJobDelete(params?.row?.id)}
            identifier="ui.projects.jobs.list.row-actions"
            disabled={disabled}
          />
      ),
    },
  ];
    return (
        <Box>
      				<Box style={{ width: '100%', display: 'flex' }}>
      				  {loading &&
                <Box display={'flex'} justifyContent={'center'} gap={1} my={2}>
                        <Spinner small />
                </Box>}
      				  {data && (
      				    <DataGrid
      				      rows={data || []}
      				      columns={columns}
      				      rowCount={data.length || 0}
      				      loading={loading}
      				      initialState={INITIAL_STATE}
                    paginationModel={pagination}
                    onPaginationModelChange={setPagination}
                    sortModel={sortModel}
                    onSortModelChange={handleSortModelChange}
                    pageSizeOptions={[5, 10, 20]}
                    sortingMode="client"
      				    />
      				  )}
      				</Box>
    			</Box>
    )
}

export default JobList;